module.exports = __webpack_public_path__ + "img/Apoptosis-OVCA_10X_OC.83cd03ef.png";